import styles from './styles.module.css';

export const MobileContainer = ({
	header,
	footer,
	children,
}: {
	header: React.ReactNode;
	footer?: React.ReactNode;
	children: React.ReactNode;
}) => {
	return (
		<div className={styles.mobileMainContainer}>
			{header}
			<div className={styles.mobileScrollableContent}>{children}</div>
			{footer}
		</div>
	);
};
